import { environment } from "../environments/environment";

export function paramsUrl(url: string) {
  const searchParams = new URLSearchParams(url);
  const params = {};
  searchParams.forEach((value: string, key: string) => {
    params[`${key}`] = value;
  });
  return params;
}

export function getAppName(url: string) {
  const urlObject: URL = new URL(url);
  const urlPathNameObject = urlObject.pathname.split("/");
  return urlPathNameObject[1];
}

export function getPageTitle(appName:string){
  let title = 'Enem RJ';
  switch (appName) {
    case 'plataforma':
      title = environment.pluriConnect.nome;
      break;
    case 'comunicacao':
      title = environment.comunicacao.nome;
      break;
    case 'agenda':
      title = environment.agenda.nome;
      break;
    case 'semchamada':
      title = environment.semChamada.nome;
      break;
    case 'corrige':
      title = environment.corrige.nome;
      break;
    case 'censo':
      title = environment.censo.nome;
      break;
    case 'led':
      title = environment.led.nome;
      break;
    case 'redacao':
      title = environment.redacao.nome;
      break;
    default:
      break;
  }
  return title;
}